import { authApi } from '@/lib/api/auth.api'
import { env } from '@/utils/env'

const ADMIN_RETURN_PARAM = 'adminReturn'
const ADMIN_RETURN_STORAGE_KEY = 'authAdminReturnUrl'

function decodeRedirectValue(value: string | null): string | null {
  if (!value) return null

  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export function validateAdminReturnTarget(value: string | null): string | null {
  const decoded = decodeRedirectValue(value)
  if (!decoded) {
    return null
  }

  try {
    const targetUrl = new URL(decoded)
    const expectedAdminUrl = new URL(env.adminAppUrl)

    if (!['http:', 'https:'].includes(targetUrl.protocol)) {
      return null
    }

    if (targetUrl.origin !== expectedAdminUrl.origin) {
      return null
    }

    return targetUrl.toString()
  } catch {
    return null
  }
}

export function getAdminReturnTarget(search: string): string | null {
  const params = new URLSearchParams(search)
  return validateAdminReturnTarget(params.get(ADMIN_RETURN_PARAM))
}

export function persistAdminReturnTarget(search: string): void {
  const target = getAdminReturnTarget(search)

  if (target) {
    localStorage.setItem(ADMIN_RETURN_STORAGE_KEY, target)
    return
  }

  localStorage.removeItem(ADMIN_RETURN_STORAGE_KEY)
}

export function popStoredAdminReturnTarget(): string | null {
  const target = validateAdminReturnTarget(
    localStorage.getItem(ADMIN_RETURN_STORAGE_KEY),
  )
  localStorage.removeItem(ADMIN_RETURN_STORAGE_KEY)
  return target
}

export async function redirectToAdminReturnTarget(
  target: string | null,
): Promise<boolean> {
  const validatedTarget = validateAdminReturnTarget(target)
  if (!validatedTarget) {
    return false
  }

  const targetUrl = new URL(validatedTarget)
  if (
    targetUrl.pathname === '/accept-invite' &&
    targetUrl.searchParams.has('token')
  ) {
    window.location.href = validatedTarget
    return true
  }

  const hasAdminAccess = await authApi.getAdminAccessStatus()
  if (!hasAdminAccess) {
    return false
  }

  window.location.href = validatedTarget
  return true
}
